import React, { useEffect } from 'react';
import { StyledContainer } from '../../components/container/styles';
import WrapperComponent from '../../components/hoc/Wrapper-component';
import { TextLarge } from '../../components/text';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const HomeScene = () => {
  const userProfile = useSelector((state) => state.line.profile);
  const { employeeStatus } = useSelector((state) => state.info);
  const location = useLocation();
  const state = location.state;

  useEffect(() => {
    if (state && !localStorage.getItem('refreshed')) {
      const branchId = state.result.branchId;
      localStorage.setItem('branchId', branchId);
      localStorage.setItem('refreshed', 'true');
      window.location.reload();
    }
  }, [state]);

  return (
    <StyledContainer>
      {employeeStatus === true ? (
        <TextLarge
          text={'ยินดีต้อนรับ ' + (userProfile?.displayName || '-')}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        />
      ) : (
        <TextLarge
          text={'กรุณาเข้าสู่ระบบ'}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        />
      )}
    </StyledContainer>
  );
};

export default WrapperComponent('HomeScene')(HomeScene);
